<div class="container-fluid" id="root" xmlns="">
    <div class="headerContainer" *ngIf="nav.ShowHeader">
        <div class="row" id="headerRow">
            <div class="col-lg-12" id="header">
                <app-header [selectedLanguage]="translate.currentLang"></app-header>
            </div>

        </div>

        <!--Tableiste-->
        <div class="row">
            <div class="col-lg-12" id="navigation">
<!--
                <button style="width:100px; height: 100px;" (click)="testinsight()">
                </button>
                -->
                <div #tabul class="nav nav-tabs" id="tabbar">
<!--
                    <button (click)="nav.toggleNav()" class="nav-button" id="nav-opener" title="Menü">
                        <img class="icon" id="menu-button" [src]="environment.storageUrl + '/icons/menu.png'" alt="Menü Symbol"/>
                    </button>
-->
                    <ng-container *ngFor="let btn of menuBtns">
                        <button
                            *ngIf="btn.show"
                            [routerLink]="btn?.routerLink"
                            routerLinkActive="active"
                            class="nav-button"
                            [ngClass]="{'active': btn.isActive}"
                            [id]="btn.id"
                            [title]="btn.title"
                            (click)="btn.id === 'card-opener' ? nav.navigateToCard() : null"
                        >
                            <img class="icon" [id]="btn.imgId" [src]="btn.src" [alt]="btn.alt" [style]="btn.style"/>
                        </button>
                    </ng-container>

                    <div *ngFor="let link of data?.activeSystem?.currentTabs, let lastTab = last; let i = index"
                         [class.active]="isTabActive(link.path)" class="tab" [ngClass]="{last: lastTab}"
                         (click)="navigateToTab(link.path)">
                        <div *ngIf="i < nav.possibleOneRow">
                            <a class="tab-link" title="{{link.path}}">
                                {{link.name}}
                            </a>

                            <div *ngIf="link.name != 'Dashboard'" class="close-button-div">
                                <a (click)="deleteTab(link)" class="close close-button-div-a">X</a>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="data?.activeSystem?.currentTabs?.length > nav.possibleOneRow">
                        <div style="width: auto !important;" class="dropdown">
                            <a aria-expanded="false" aria-haspopup="true" class="btn dropdown-toggle"
                               data-toggle="dropdown"
                               id="dropdownMenuLink" role="button" routerLinkActive="active">
                            </a>
                            <div aria-labelledby="dropdownMenuLink" class="dropdown-menu">
                                <div *ngFor="let link of data?.activeSystem?.currentTabs; let i = index">
                                    <div style="width: auto !important;" *ngIf="i >= nav.possibleOneRow">

                                        <div class="dropdown-item" [class.active]="isTabActive(link.path)">

                                            <a (click)="navigateToTab(link.path)"
                                               title="{{link.location}}&#10;{{link.system}}" style="cursor: pointer;"> {{link.name}} </a>
                                            <div *ngIf="link.path != 'dashboard'" class="dropdown-item-div">
                                                <a (click)="deleteTab(link)" class="close dropdown-item-div-a">X</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row" [ngClass]="{'main': nav.ShowHeader}" id="main">

        <div class="col-lg-12" id="contentFooter" [ngClass]="{'noHeader': !nav.ShowHeader}">
            <div class="row" id="contentRow">
                <div class="col-lg-12" id="content" [ngClass]="{'noPadding': !nav.ShowHeader}">


                    <nav #menu [style.visibility]="nav.NavOpen" id="menu">

                        <ul class="parent-menu" id="ul">
                            <!--
                            <div class="form-group">
                                <input type="text" [(ngModel)]="searchText" (ngModelChange)="search()" placeholder="Suchen..." title="Suchbegriff eingeben." class="form-control">
                            </div>
                            -->

                            <!--Auswahl Kunde/Standort/Anlage-->

                            <li>
                                <div *ngIf="data?.customer?.length > 0">
                                    <div class="form-group">
                                        <label for="details">{{'Unternehmen' | translate}}: </label>
                                        <div>
                                            <select [(ngModel)]="data.activeCompany"
                                                    (change)="selectCustomerOfIndex($event.target.selectedIndex, true)"
                                                    class="form-control" id="details" name="customer">
                                                <option *ngFor="let customer of data.customer" [ngValue]="customer">
                                                    {{customer.name}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li>
                                <div *ngIf="data.activeCompany?.locations?.size > 0">
                                    <div class="form-group">
                                        <label for="loc">{{'Standort' | translate}}: </label>
                                        <div *ngIf="(data.activeLocation != null)">
                                            <select [(ngModel)]="data.activeLocation"
                                                    (change)="selectLocationOfIndex($event.target.selectedIndex, true)"
                                                    class="form-control" id="loc" name="location">
                                                <option *ngFor="let location of Array.from(data.activeCompany.locations.values())"
                                                        [ngValue]="location">
                                                    {{location.name}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li style="border-bottom: 1px solid lightgray">
                                <div *ngIf="data.activeLocation?.systems?.size > 0">
                                    <div class="form-group">
                                        <label for="sys" i18n>{{'Anlage' | translate}}: </label>
                                        <div *ngIf="data.activeSystem != null">

                                            <select [(ngModel)]="data.activeSystem"
                                                    (change)="selectSystemOfIndex($event.target.selectedIndex)"
                                                    class="form-control" id="sys" name="system">
                                                <option *ngFor="let system of Array.from(data.activeLocation.systems.values())"
                                                        [ngValue]="system">
                                                    {{system.name}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <!--Navigation Links-->

                            <div *ngIf="data.activeSystem != null" id="dynamicNav">

                                <li *ngIf="auth.isBronze() && data?.activeSystem != null" routerLinkActive="active">
                                    <a (click)="nav.navigateToThing(data.activeSystem.dashboard)">Dashboard</a>
                                </li>

                                <app-navigation-left
                                        *ngIf="auth.isSilver()  && data?.activeSystem?.allThingTypes.has('OLS')"
                                        [name]="'One level Shuttle'"
                                        [thingRoute]="'OLS/'"
                                        [things]="sortArray(data?.activeSystem?.allThingTypes.get('OLS'))"></app-navigation-left>

                                <app-navigation-left
                                        *ngIf="auth.isSilver()  && data?.activeSystem?.allThingTypes.has('OLSE')"
                                        [name]="'One level Shuttle - E'"
                                        [thingRoute]="'OLSE/'"
                                        [things]="sortArray(data?.activeSystem?.allThingTypes.get('OLSE'))"></app-navigation-left>

                                <app-navigation-left
                                        *ngIf="auth.isSilver()  && data?.activeSystem?.allThingTypes.has('OLSX')"
                                        [name]="'One level Shuttle X'"
                                        [thingRoute]="'OLSX/'"
                                        [things]="sortArray(data?.activeSystem?.allThingTypes.get('OLSX'))"></app-navigation-left>

                                <app-navigation-left
                                        *ngIf="auth.isSilver() && data?.activeSystem?.allThingTypes.has('OLPS')"
                                        [name]="'StoreBiter 500'"
                                        [thingRoute]="'OLPS/'"
                                        [things]="sortArray(data?.activeSystem?.allThingTypes.get('OLPS'))"></app-navigation-left>

                                <app-navigation-left
                                        *ngIf="auth.isSilver() && data?.activeSystem?.allThingTypes.has('MLS')"
                                        [name]="'Multi level Shuttle'"
                                        [thingRoute]="'MLS/'"
                                        [things]="sortArray(data?.activeSystem?.allThingTypes.get('MLS'))"></app-navigation-left>

                                <app-navigation-left
                                        *ngIf="auth.isSilver() && data?.activeSystem?.allThingTypes.has('FTS')"
                                        [name]="'Fahrerloses Transport System'"
                                        [thingRoute]="'FTS/'"
                                        [things]="sortArray(data?.activeSystem?.allThingTypes.get('FTS'))"></app-navigation-left>

                                <app-navigation-left
                                        *ngIf="auth.isSilver() && data?.activeSystem?.allThingTypes.has('RBG')"
                                        [name]="'Regalbediengerät' | translate"
                                        [thingRoute]="'RBG/'"
                                        [things]="sortArray(data?.activeSystem?.allThingTypes.get('RBG'))"></app-navigation-left>

                                <app-navigation-left
                                        *ngIf="auth.isSilver() && data?.activeSystem?.allThingTypes.has('HCV')"
                                        [name]="'Horizontalförderer'"
                                        [thingRoute]="'HCV/'"
                                        [things]="sortArray(data?.activeSystem?.allThingTypes.get('HCV'))"></app-navigation-left>

                                <app-navigation-left
                                        *ngIf="auth.isSilver() && data?.activeSystem?.allThingTypes.has('VCV')"
                                        [name]="'Heber' | translate"
                                        [thingRoute]="'VCV/'"
                                        [things]="sortArray(data?.activeSystem?.allThingTypes.get('VCV'))"></app-navigation-left>

                                <app-navigation-left
                                        *ngIf="auth.isSilver() && data?.activeSystem?.allThingTypes.has('HDS')"
                                        [name]="'HDS'"
                                        [thingRoute]="'HDS/'"
                                        [things]="sortArray(data?.activeSystem?.allThingTypes.get('HDS'))"></app-navigation-left>

                                <app-navigation-left
                                        *ngIf="auth.isSilver() && data?.activeSystem?.allThingTypes.has('GDP')"
                                        [name]="'GridPick'"
                                        [thingRoute]="'GDP/'"
                                        [things]="sortArray(data?.activeSystem?.allThingTypes.get('GDP'))"></app-navigation-left>

                                <app-navigation-left
                                        *ngIf="auth.isSilver() && data?.activeSystem?.allThingTypes.has('CONVER')"
                                        [name]="'Conver'"
                                        [thingRoute]="'CONVER/'"
                                        [things]="sortArray(data?.activeSystem?.allThingTypes.get('CONVER'))"></app-navigation-left>

                                <app-navigation-left
                                        *ngIf="auth.isSilver() && data?.activeSystem?.allThingTypes.has('LSC')"
                                        [name]="'Leuze Scanner'"
                                        [thingRoute]="'LSC/'"
                                        [things]="sortArray(data?.activeSystem?.allThingTypes.get('LSC'))"></app-navigation-left>

                                <app-navigation-left
                                        *ngIf="auth.isSilver() && data?.activeSystem?.allThingTypes.has('SSAGM')"
                                        [name]="'Speedsorter Allgemein'"
                                        [thingRoute]="'SSAGM/'"
                                        [things]="sortArray(data?.activeSystem?.allThingTypes.get('SSAGM'))"></app-navigation-left>

                                <app-navigation-left
                                        *ngIf="auth.isSilver() && data?.activeSystem?.allThingTypes.has('SSDTM')"
                                        [name]="'Speedsorter DTM'"
                                        [thingRoute]="'SSDTM/'"
                                        [things]="sortArray(data?.activeSystem?.allThingTypes.get('SSDTM'))"></app-navigation-left>

                                <app-navigation-left
                                        *ngIf="auth.isSilver() && data?.activeSystem?.allThingTypes.has('SSIF')"
                                        [name]="'Speedsorter Infeed'"
                                        [thingRoute]="'SSIF/'"
                                        [things]="sortArray(data?.activeSystem?.allThingTypes.get('SSIF'))"></app-navigation-left>

                                <app-navigation-left
                                        *ngIf="auth.isSilver() && data?.activeSystem?.allThingTypes.has('SSES')"
                                        [name]="'Speedsorter Endstelle'"
                                        [thingRoute]="'SSES/'"
                                        [things]="sortArray(data?.activeSystem?.allThingTypes.get('SSES'))"></app-navigation-left>

                                <app-navigation-left
                                        *ngIf="auth.isSilver() && data?.activeSystem?.allThingTypes.has('BOT')"
                                        [name]="'Gridstore Bot'"
                                        [thingRoute]="'BOT/'"
                                        [things]="sortArray(data?.activeSystem?.allThingTypes.get('BOT'))"></app-navigation-left>

                                <li *ngIf="auth.isPlatinum() && data?.activeSystem?.PowerBiConfig?.Testdrive != null"
                                    routerLinkActive="active">
                                    <a (click)="nav.navigateToTestdrive()">{{'Testfahrt' | translate}}</a>
                                </li>

                            </div>

                        </ul>
                    </nav>

                    <div *ngIf="data.customer != null; else loading">
                        <router-outlet id="outlet"></router-outlet>
                    </div>

                    <!-- <app-footer></app-footer> -->
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #loading>
    <app-loading [Colour]="'red'" [Text]="'Daten werden abgerufen'"></app-loading>
</ng-template>
